import { middleware } from './middleware';
import { addSnippet } from './snippet';
import { SegmentWindow } from './types';
import config from '~/config';

const segmentWindow: SegmentWindow = window;

export const initAnalytics = () => {
  addSnippet(config.SEGMENT_WRITE_KEY);
  const segment = segmentWindow.analytics;
  if (config.SEGMENT_WRITE_KEY !== '') {
    middleware.forEach(segment.addSourceMiddleware);
    segment.load(config.SEGMENT_WRITE_KEY);
  }
};
